import React from 'react';
import i18n from 'i18n';
import QuestionMark from '@mui/icons-material/QuestionMark';
import { RouteConfigurationModel } from 'models';
import { NoAccess, NotFound } from 'components';
import { RouteNames } from 'config/routeNames';
import MenuCardPage from 'components/menu-card/MenuCardPage/MenuCardPage';
import ComponentsPage from 'pages/Components/ComponentsPage';
import ReadingUnitsPage from 'pages/Leo/ReadingUnits/ReadingUnitsPage';
import ReadingCenterPage from 'pages/Leo/ReadingCenter/ReadingCenterPage';
import ReadingUnitDetailsPage from 'pages/Leo/ReadingUnitDetails/ReadingUnitDetailsPage';
import WorkersPage from 'pages/Kozos/Workers/WorkersPage';
import HealthAndSafetyPage from 'pages/Kozos/Statistics/HealthAndSafety/HealthAndSafetyPage';
import ReadingStatisticsPage from 'pages/Leo/Statistics/ReadingStatistics/ReadingStatisticsPage';
import NotifyLogsPage from 'pages/Leo/Logs/NotifyLogs/NotifyLogsPage';
import EstimationExclusionsPage from 'pages/Leo/Statistics/EstimationExclusions/EstimationExclusionsPage';
import EventLogPage from 'pages/Kozos/Statistics/EventLog/EventLogPage';
import EmergencyCodeStatisticsPage from 'pages/Leo/Statistics/EmergencyCodeStatistics/EmergencyCodeStatisticsPage';
import TimeLogPage from 'pages/Kozos/Statistics/TimeLog/TimeLogPage';
import AreaExclusionsPage from 'pages/Ucse/AreaExclusions/AreaExclusionsPage';
import OpemUsers from 'pages/Kozos/OpemUsers/OpemUsersPage';
import UcseAvailabilityPage from 'pages/Ucse/UcseAvailability/UcseAvailabilityPage';
import ReportCodesByWorkerPage from 'pages/Leo/Monitoring/ReportCodesByWorker/ReportCodesByWorkerPage';
import ReportCodes from 'pages/Leo/Monitoring/ReportCodes/ReportCodesPage';
import ReadingFailureReasonsPage from 'pages/Leo/Monitoring/ReadingFailureReasons/ReadingFailureReasonsPage';
import OrderWithReports from 'pages/Leo/Statistics/OrderWithReports/OrderWithReports';
import UnreadableOrdersPage from 'pages/Leo/Statistics/UnreadableOrders/UnreadableOrdersPage';
import CommunicationLogPage from 'pages/Leo/Logs/CommunicationLog/CommunicationLogPage';
import DocumentLogPage from 'pages/Leo/Logs/DocumentLog/DocumentLogPage';
import PhotoFailureReasonsPage from 'pages/Leo/Statistics/PhotoFailureReasons/PhotoFailureReasonsPage';
import ReadingResultStatisticsPage from 'pages/Leo/Monitoring/ReadingResults/ReadingResultStatisticsPage';
import UcseFreeCapacityPage from 'pages/Kozos/Statistics/FreeCapacity/UcseFreeCapacity';
import NotCompletedAfterDeadlinePage from 'pages/Ucse/NotCompletedAfterDeadline/NotCompletedAfterDeadlinePage';
import AreaWorkerPage from 'pages/Ucse/AreaWorker/AreaWorkerPage';
import UcseOrdersPage from 'pages/Ucse/UcseOrders/UcseOrdersPage';
import CompletedAfterDeadlinePage from 'pages/Ucse/CompletedAfterDeadline/CompletedAfterDeadlinePage';
import ImportTaskPage from 'pages/Kozos/Statistics/ImportTask/ImportTaskPage';
import DataModificationsPage from 'pages/Leo/Monitoring/DataModifications/DataModificationsPage';
import WageItemsPage from 'pages/Kozos/PerformanceBasedPay/WageItems/WageItemsPage';
import PerformanceBasedPayPage from 'pages/Kozos/PerformanceBasedPay/PerformanceBasedPay/PerformanceBasedPayPage';
import PerformanceTariffsPage from 'pages/Kozos/PerformanceBasedPay/Tariffs/PerformanceTariffs/PerformanceTariffsPage';
import PerformanceTariffsNotReadablePage from 'pages/Kozos/PerformanceBasedPay/Tariffs/PerformanceTariffsNotReadable/PerformanceTariffsNotReadablePage';
import PerformanceTariffsReportsPage from 'pages/Kozos/PerformanceBasedPay/Tariffs/PerformanceTariffsReports/PerformanceTariffsReportsPage';
import SapUploadManualPage from 'pages/Kozos/SapUploadManual/SapUploadManualPage';
import ValueSetUpdatePage from 'pages/Kozos/ValueSetUpdate/ValueSetUpdatePage';
import SubmittedSapOrdersPage from 'pages/Kozos/SubmittedSapOrders/SubmittedSapOrdersPage';
import AppointmentPage from 'pages/Ucse/Appointment/AppointmentPage';
import ReadingOrdersPage from 'pages/Leo/ReadingOrders/ReadingOrdersPage';
import UploadHolidaysPage from 'pages/Kozos/UploadHolidays/UploadHolidaysPage';
import UploadDocumentsPage from 'pages/Kozos/UploadDocuments/UploadDocumentsPage';
import LoadTasksFromExcelPage from 'pages/Kozos/LoadTasks/LoadTasksFromExcelPage';
import SwapOrderIdsPage from 'pages/Kozos/LoadTasks/SwapOrderIdsPage';
import ReadingTimePage from 'pages/Kozos/PerformanceBasedPay/ReadingTime/ReadingTimePage';
import { CommentCodeTransferPage } from 'pages/Leo/CommentCodes/CommentCodeTransfer/CommentCodeTransferPage';
import { CommentCodeListPage } from 'pages/Leo/CommentCodes/CommentCodeList/CommentCodeListPage';
import ConsumptionPlaceUploadPage from 'pages/Kozos/ConsumptionPlaceUpload/ConsumptionPlaceUploadPage';
import PermissionGroupsPage from 'pages/Kozos/PermissionGroups/PermissionGroupsPage';
import PermissionGroupDetailsPage from 'pages/Kozos/PermissionGroups/PermissionGroupDetailsPage';
import FieldDeviceSettingsPage from 'pages/Kozos/FieldDeviceSettings/FieldDeviceSettingsPage';

export const routes: RouteConfigurationModel[] = [
  {
    icon: QuestionMark,
    path: 'no-access',
    link: '/no-access',
    component: <NoAccess />,
    title: () => i18n.t('HOME.PAGE_TITLE'),
  },
  {
    icon: QuestionMark,
    path: 'not-found',
    link: '/not-found',
    component: <NotFound />,
    title: () => i18n.t('HOME.PAGE_TITLE'),
  },
  {
    icon: QuestionMark,
    path: 'components',
    link: '/components',
    component: <ComponentsPage />,
    title: () => i18n.t('COMPONENTS.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.UCSE,
    link: `/${RouteNames.UCSE}`,
    component: <MenuCardPage parentRoute={RouteNames.UCSE} />,
    title: () => i18n.t('UCSE.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.UCSE_STATISZTIKAK,
    link: `/${RouteNames.UCSE_STATISZTIKAK}`,
    component: <MenuCardPage parentRoute={RouteNames.UCSE_STATISZTIKAK} />,
    title: () => i18n.t('UCSE_STATISZTIKAK.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.KOZOS_TELJESITMENYBER,
    link: `/${RouteNames.KOZOS_TELJESITMENYBER}`,
    component: <MenuCardPage parentRoute={RouteNames.KOZOS_TELJESITMENYBER} />,
    title: () => i18n.t('KOZOS_TELJESITMENYBER.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.KOZOS_FUNKCIOK,
    link: `/${RouteNames.KOZOS_FUNKCIOK}`,
    component: <MenuCardPage parentRoute={RouteNames.KOZOS_FUNKCIOK} />,
    title: () => i18n.t('KOZOS_FUNKCIOK.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.LEO,
    link: `/${RouteNames.LEO}`,
    component: <MenuCardPage parentRoute={RouteNames.LEO} />,
    title: () => i18n.t('LEO.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.LEO_STATISZTIKAK,
    link: `/${RouteNames.LEO_STATISZTIKAK}`,
    component: <MenuCardPage parentRoute={RouteNames.LEO_STATISZTIKAK} />,
    title: () => i18n.t('LEO_STATISZTIKAK.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.LEO_MONITORING,
    link: `/${RouteNames.LEO_MONITORING}`,
    component: <MenuCardPage parentRoute={RouteNames.LEO_MONITORING} />,
    title: () => i18n.t('LEO_MONITORING.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.LEO_LOGOK,
    link: `/${RouteNames.LEO_LOGOK}`,
    component: <MenuCardPage parentRoute={RouteNames.LEO_LOGOK} />,
    title: () => i18n.t('LEO_LOGOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READING_UNITS',
    path: RouteNames.LEO_LEO_EGYSEGEK,
    link: `/${RouteNames.LEO_LEO_EGYSEGEK}`,
    component: <ReadingUnitsPage />,
    title: () => i18n.t('LEO_LEO_EGYSEGEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READING_ORDERS',
    path: RouteNames.LEO_LEO_RENDELESEK,
    link: `/${RouteNames.LEO_LEO_RENDELESEK}`,
    component: <ReadingOrdersPage />,
    title: () => i18n.t('LEO_LEO_RENDELESEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READING_UNIT_DETAILS',
    path: RouteNames.LEO_LEO_EGYSEG_RESZLETEK,
    link: `/${RouteNames.LEO_LEO_EGYSEG_RESZLETEK}`,
    component: <ReadingUnitDetailsPage />,
    title: () => i18n.t('LEO_LEO_EGYSEG_RESZLETEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READING_CENTERS',
    path: RouteNames.LEO_LEO_KOZPONT_ALAPERTEKEK,
    link: `/${RouteNames.LEO_LEO_KOZPONT_ALAPERTEKEK}`,
    component: <ReadingCenterPage />,
    title: () => i18n.t('LEO_LEO_KOZPONT_ALAPERTEKEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READING_COMMENT_CODES',
    path: RouteNames.LEO_MEGJEGYZES_KODOK,
    link: `/${RouteNames.LEO_MEGJEGYZES_KODOK}`,
    component: <CommentCodeListPage />,
    title: () => i18n.t('LEO_MEGJEGYZES_KODOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READING_COMMENT_CODES',
    mode: 'edit',
    path: RouteNames.LEO_MEGJEGYZES_KODOK_ATVETEL,
    link: `/${RouteNames.LEO_MEGJEGYZES_KODOK_ATVETEL}`,
    component: <CommentCodeTransferPage />,
    title: () => i18n.t('LEO_MEGJEGYZES_KODOK_ATVETEL.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'WORKERS',
    path: RouteNames.KOZOS_MUNKAVEGZOK,
    link: `/${RouteNames.KOZOS_MUNKAVEGZOK}`,
    component: <WorkersPage />,
    title: () => i18n.t('MUNKAVEGZOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'SAP_SUBMITTED_READING_ORDERS',
    path: RouteNames.KOZOS_SAP_BEKULDOTT_LEO_RENDELESEK,
    link: `/${RouteNames.KOZOS_SAP_BEKULDOTT_LEO_RENDELESEK}`,
    component: <SubmittedSapOrdersPage />,
    title: () => i18n.t('KOZOS_SAP_BEKULDOTT_LEO_RENDELESEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'OPEM_USERS',
    path: RouteNames.KOZOS_OPEM_FELHASZNALOK,
    link: `/${RouteNames.KOZOS_OPEM_FELHASZNALOK}`,
    component: <OpemUsers />,
    title: () => i18n.t('KOZOS_OPEM_FELHASZNALOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'PERMISSION_GROUPS',
    path: RouteNames.KOZOS_JOGOSULTSAGI_CSOPORTOK,
    link: `/${RouteNames.KOZOS_JOGOSULTSAGI_CSOPORTOK}`,
    component: <PermissionGroupsPage />,
    title: () => i18n.t('KOZOS_JOGOSULTSAGI_CSOPORTOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'PERMISSION_GROUPS',
    path: RouteNames.KOZOS_JOGOSULTSAGI_CSOPORTOK_RESZLETEK,
    link: `/${RouteNames.KOZOS_JOGOSULTSAGI_CSOPORTOK_RESZLETEK}`,
    component: <PermissionGroupDetailsPage />,
    title: () => i18n.t('KOZOS_JOGOSULTSAGI_CSOPORTOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'TIME_LOG',
    path: RouteNames.KOZOS_TIME_LOG,
    link: `/${RouteNames.KOZOS_TIME_LOG}`,
    component: <TimeLogPage />,
    title: () => i18n.t('KOZOS_MUNKAVEGZOK_NAPLOJA.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'UCSE_ORDERS',
    path: RouteNames.UCSE_RENDELESEK,
    link: `/${RouteNames.UCSE_RENDELESEK}`,
    component: <UcseOrdersPage />,
    title: () => i18n.t('UCSE_RENDELESEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'AREA_WORKER_AVAILABILITY',
    path: RouteNames.UCSE_KORZETKIZARASOK,
    link: `/${RouteNames.UCSE_KORZETKIZARASOK}`,
    component: <AreaExclusionsPage />,
    title: () => i18n.t('UCSE_KORZETKIZARASOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'UCSE_CAPACITY_BY_AREA',
    path: RouteNames.UCSE_TELEPULES_LISTA_KAPACITAS,
    link: `/${RouteNames.UCSE_TELEPULES_LISTA_KAPACITAS}`,
    component: <UcseFreeCapacityPage />,
    title: () => i18n.t('UCSE_TELEPULES_LISTA_KAPACITAS.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'HS_REPORTS',
    path: RouteNames.KOZOS_H_S_JELZESEK,
    link: `/${RouteNames.KOZOS_H_S_JELZESEK}`,
    component: <HealthAndSafetyPage />,
    title: () => i18n.t('KOZOS_H_S_JELZESEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READING_STATISTICS',
    path: RouteNames.LEO_LEOLVASO_STATISZTIKA,
    link: `/${RouteNames.LEO_LEOLVASO_STATISZTIKA}`,
    component: <ReadingStatisticsPage />,
    title: () => i18n.t('LEO_LEOLVASO_STATISZTIKA.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'OPEM_INTERFACE_LOG',
    path: RouteNames.LEO_KOMMUNIKACIOS_LOGOK,
    link: `/${RouteNames.LEO_KOMMUNIKACIOS_LOGOK}`,
    component: <CommunicationLogPage />,
    title: () => i18n.t('LEO_KOMMUNIKACIOS_LOGOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'DOCUMENT_LOG',
    path: RouteNames.LEO_BIZONYLATOK_NAPLOJA,
    link: `/${RouteNames.LEO_BIZONYLATOK_NAPLOJA}`,
    component: <DocumentLogPage />,
    title: () => i18n.t('LEO_BIZONYLATOK_NAPLOJA.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READING_FAILURE_REASON_STATISTICS',
    path: RouteNames.LEO_NEM_LEOLVASHATOSAGI_OKOK,
    link: `/${RouteNames.LEO_NEM_LEOLVASHATOSAGI_OKOK}`,
    component: <ReadingFailureReasonsPage />,
    title: () => i18n.t('LEO_NEM_LEOLVASHATOSAGI_OKOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'NOTIFIED_READING_RESULTS',
    path: RouteNames.LEO_ERTESITO_JELZESEK,
    link: `/${RouteNames.LEO_ERTESITO_JELZESEK}`,
    component: <NotifyLogsPage />,
    title: () => i18n.t('NOTIFY_LOGS.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'ORDERS_WITH_REPORTS',
    path: RouteNames.LEO_JELENTESEKET_TARTALMAZO_RENDELESEK,
    link: `/${RouteNames.LEO_JELENTESEKET_TARTALMAZO_RENDELESEK}`,
    component: <OrderWithReports />,
    title: () => i18n.t('LEO_TOBBSZOROS_JELENTES.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'ESTIMATION_EXCLUSIONS',
    path: RouteNames.LEO_BECSLESBOL_KIZARASOK,
    link: `/${RouteNames.LEO_BECSLESBOL_KIZARASOK}`,
    component: <EstimationExclusionsPage />,
    title: () => i18n.t('LEO_BECSLESBOL_KIZARAS.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'OPEM_EVENT_LOG',
    path: RouteNames.KOZOS_MUVELETI_NAPLO,
    link: `/${RouteNames.KOZOS_MUVELETI_NAPLO}`,
    component: <EventLogPage />,
    title: () => i18n.t('KOZOS_MUVELETI_NAPLO.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'EMERGENCY_CODES',
    path: RouteNames.LEO_MUNKAVEDELMI_JELZESEK,
    link: `/${RouteNames.LEO_MUNKAVEDELMI_JELZESEK}`,
    component: <EmergencyCodeStatisticsPage />,
    title: () => i18n.t('LEO_MUNKAVEDELMI_JELZESEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'UCSE_AVAILABILITY',
    path: RouteNames.UCSE_RENDELKEZESRE_ALLAS,
    link: `/${RouteNames.UCSE_RENDELKEZESRE_ALLAS}`,
    component: <UcseAvailabilityPage />,
    title: () => i18n.t('UCSE_RENDELKEZESRE_ALLAS.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'AREA_WORKERS',
    path: RouteNames.UCSE_KORZETEK_LEOLVASOHOZ_RENDELESE,
    link: `/${RouteNames.UCSE_KORZETEK_LEOLVASOHOZ_RENDELESE}`,
    component: <AreaWorkerPage />,
    title: () => i18n.t('UCSE_KORZETEK_LEOLVASOHOZ_RENDELESE.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'REPORT_CODES_BY_WORKER',
    path: RouteNames.LEO_JELENTES_KODOK_LEOLVASONKENT,
    link: `/${RouteNames.LEO_JELENTES_KODOK_LEOLVASONKENT}`,
    component: <ReportCodesByWorkerPage />,
    title: () => i18n.t('LEO_JELENTES_KODOK_LEOLVASONKENT.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'UNREADABLE_ORDERS',
    path: RouteNames.LEO_NEM_LEOLVASHATO_RENDELESEK,
    link: `/${RouteNames.LEO_NEM_LEOLVASHATO_RENDELESEK}`,
    component: <UnreadableOrdersPage />,
    title: () => i18n.t('LEO_NEM_LEOLVASHATO_RENDELESEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'PHOTO_NOT_TAKEN_REASONS',
    path: RouteNames.LEO_FOTO_MEGHIUSULASOK_OKA,
    link: `/${RouteNames.LEO_FOTO_MEGHIUSULASOK_OKA}`,
    component: <PhotoFailureReasonsPage />,
    title: () => i18n.t('LEO_FOTO_MEGHIUSULASOK_OKA.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'REPORT_CODES',
    path: RouteNames.LEO_JELENTES_KODOK,
    link: `/${RouteNames.LEO_JELENTES_KODOK}`,
    component: <ReportCodes />,
    title: () => i18n.t('LEO_JELENTES_KODOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READING_RESULTS',
    path: RouteNames.LEO_LEOLVASOTTSAG,
    link: `/${RouteNames.LEO_LEOLVASOTTSAG}`,
    component: <ReadingResultStatisticsPage />,
    title: () => i18n.t('LEO_LEOLVASOTTSAG.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'UCSE_NOT_COMPLETED_AFTER_DEADLINE',
    path: RouteNames.UCSE_HATARIDORE_NEM_TELJESULT_FELADATOK,
    link: `/${RouteNames.UCSE_HATARIDORE_NEM_TELJESULT_FELADATOK}`,
    component: <NotCompletedAfterDeadlinePage />,
    title: () => i18n.t('UCSE_HATARIDORE_NEM_TELJESULT_FELADATOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'UCSE_COMPLETED_AFTER_DEADLINE',
    path: RouteNames.UCSE_HATARIDO_UTAN_TELJESULT_FELADATOK,
    link: `/${RouteNames.UCSE_HATARIDO_UTAN_TELJESULT_FELADATOK}`,
    component: <CompletedAfterDeadlinePage />,
    title: () => i18n.t('UCSE_HATARIDO_UTAN_TELJESULT_FELADATOK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'ORDER_IMPORT_XML',
    path: RouteNames.KOZOS_FELADAT_IMPORT,
    link: `/${RouteNames.KOZOS_FELADAT_IMPORT}`,
    component: <ImportTaskPage />,
    title: () => i18n.t('KOZOS_FELADAT_IMPORT.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'DATA_CORRECTIONS',
    path: RouteNames.LEO_ADATPONTOSITASOK,
    link: `/${RouteNames.LEO_ADATPONTOSITASOK}`,
    component: <DataModificationsPage />,
    title: () => i18n.t('LEO_ADATPONTOSITASOK.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.KOZOS_TARIFAK,
    link: `/${RouteNames.KOZOS_TARIFAK}`,
    component: <MenuCardPage parentRoute={RouteNames.KOZOS_TARIFAK} />,
    title: () => i18n.t('KOZOS_TARIFAK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'TARIFF_PERFORMANCE_METRICS',
    path: RouteNames.KOZOS_TARIFAK_BERELEMEK,
    link: `/${RouteNames.KOZOS_TARIFAK_BERELEMEK}`,
    component: <PerformanceTariffsPage />,
    title: () => i18n.t('KOZOS_TARIFAK_BERELEMEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'TARIFF_READING_FAILURE_REASONS',
    path: RouteNames.KOZOS_TARIFAK_NEM_LEOLVASHATOSAGI_OK,
    link: `/${RouteNames.KOZOS_TARIFAK_NEM_LEOLVASHATOSAGI_OK}`,
    component: <PerformanceTariffsNotReadablePage />,
    title: () => i18n.t('KOZOS_TARIFAK_NEM_LEOLVASHATOSAGI_OK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'TARIFF_REPORTS',
    path: RouteNames.KOZOS_TARIFAK_JELENTESEK,
    link: `/${RouteNames.KOZOS_TARIFAK_JELENTESEK}`,
    component: <PerformanceTariffsReportsPage />,
    title: () => i18n.t('KOZOS_TARIFAK_JELENTESEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'PERFORMANCE_METRICS',
    path: RouteNames.KOZOS_BERELEMEK,
    link: `/${RouteNames.KOZOS_BERELEMEK}`,
    component: <WageItemsPage />,
    title: () => i18n.t('KOZOS_BERELEMEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'PERFORMANCE_METRIC_READING_TIME',
    path: RouteNames.KOZOS_TELJESITMENYBER_SULYSZAMOK,
    link: `/${RouteNames.KOZOS_TELJESITMENYBER_SULYSZAMOK}`,
    component: <ReadingTimePage />,
    title: () => i18n.t('READINGTIME.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'PERFORMANCE_BASED_PAY',
    path: RouteNames.KOZOS_TELJESITMENYBEREK,
    link: `/${RouteNames.KOZOS_TELJESITMENYBEREK}`,
    component: <PerformanceBasedPayPage />,
    title: () => i18n.t('KOZOS_TELJESITMENYBEREK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'SAP_UPLOAD_MANUAL_TRIGGER',
    path: RouteNames.KOZOS_SAP_FELTOLTES_MANUALIS,
    link: `/${RouteNames.KOZOS_SAP_FELTOLTES_MANUALIS}`,
    component: <SapUploadManualPage />,
    title: () => i18n.t('KOZOS_SAP_FELTOLTES_MANUALIS.TITLE'),
  },
  {
    icon: QuestionMark,
    // Gated on SEED_DATA_LOAD, not VALUE_SETS: this page's only action re-triggers the /seed
    // endpoint, which the backend guards with SEED_DATA_LOAD EDIT.
    scope: 'SEED_DATA_LOAD',
    path: RouteNames.KOZOS_ERTEKKESZLET,
    link: `/${RouteNames.KOZOS_ERTEKKESZLET}`,
    component: <ValueSetUpdatePage />,
    title: () => i18n.t('KOZOS_ERTEKKESZLET.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'SM_ORDER_APPOINTMENTS',
    path: RouteNames.UCSE_IDOPONTFOGLALAS,
    link: `/${RouteNames.UCSE_IDOPONTFOGLALAS}`,
    component: <AppointmentPage />,
    title: () => i18n.t('UCSE_IDOPONTFOGLALAS.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'HR_CALENDAR_UPLOAD',
    path: RouteNames.KOZOS_MUNKASZUNETI_NAPOK_FELTOLTESE,
    link: `/${RouteNames.KOZOS_MUNKASZUNETI_NAPOK_FELTOLTESE}`,
    component: <UploadHolidaysPage />,
    title: () => i18n.t('KOZOS_MUNKASZUNETI_NAPOK_FELTOLTESE.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'READER_DOCUMENT_UPLOAD',
    path: RouteNames.KOZOS_DOKUMENTUM_FELTOLTES,
    link: `/${RouteNames.KOZOS_DOKUMENTUM_FELTOLTES}`,
    component: <UploadDocumentsPage />,
    title: () => i18n.t('KOZOS_DOKUMENTUM_FELTOLTES.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.KOZOS_FELADAT_BETOLTES,
    link: `/${RouteNames.KOZOS_FELADAT_BETOLTES}`,
    component: <MenuCardPage parentRoute={RouteNames.KOZOS_FELADAT_BETOLTES} />,
    title: () => i18n.t('KOZOS_FELADAT_BETOLTES.TITLE'),
  },
  {
    icon: QuestionMark,
    path: RouteNames.KOZOS_FOGYASZTASI_HELYEK,
    link: `/${RouteNames.KOZOS_FOGYASZTASI_HELYEK}`,
    component: <MenuCardPage parentRoute={RouteNames.KOZOS_FOGYASZTASI_HELYEK} />,
    title: () => i18n.t('FOGYASZTASI_HELYEK.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'CONSUMPTION_PLACE_LOADER',
    path: RouteNames.KOZOS_FOGYASZTASI_HELYEK_BETOLTESE,
    link: `/${RouteNames.KOZOS_FOGYASZTASI_HELYEK_BETOLTESE}`,
    component: <ConsumptionPlaceUploadPage />,
    title: () => i18n.t('FOGYASZTASI_HELYEK_BETOLTESE.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'ORDER_IMPORT_EXCEL',
    path: RouteNames.KOZOS_FELADAT_BETOLTES_EXCELBOL,
    link: `/${RouteNames.KOZOS_FELADAT_BETOLTES_EXCELBOL}`,
    component: <LoadTasksFromExcelPage />,
    title: () => i18n.t('KOZOS_FELADAT_BETOLTES_EXCELBOL.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'ORDER_ID_MAPPING',
    path: RouteNames.KOZOS_RENDELES_AZONOSITOK_CSEREJE,
    link: `/${RouteNames.KOZOS_RENDELES_AZONOSITOK_CSEREJE}`,
    component: <SwapOrderIdsPage />,
    title: () => i18n.t('KOZOS_RENDELES_AZONOSITOK_CSEREJE.TITLE'),
  },
  {
    icon: QuestionMark,
    scope: 'FIELD_DEVICE_SETTINGS',
    path: RouteNames.KOZOS_TEREPI_ESZKOZ_BEALLITASOK,
    link: `/${RouteNames.KOZOS_TEREPI_ESZKOZ_BEALLITASOK}`,
    component: <FieldDeviceSettingsPage />,
    title: () => i18n.t('KOZOS_TEREPI_ESZKOZ_BEALLITASOK.TITLE'),
  },
];
